import React, { useState } from 'react';
import {Link} from "react-router-dom";
import axios from 'axios';
import { useMst } from '../models/root';
import { observer } from "mobx-react-lite";
import {myIdea} from '../models/myIdeas.js';
import apis from "../assets/js/apis.js";

const IdeaFunctions = observer((props) =>{
    
    const A = "ADD IDEA";
    const B = "EDIT IDEA";
    const C = "IMPROVE IDEA";
    const D = "SUGGESTION";

    const {variables, myIdeas} = useMst();

    const [final, setFinal] = useState(false); 
    const [text, setText] = useState("")

    const AddorChangeIdea = () =>{
        const options = {
            headers: {'Authorization': `Bearer ${variables.access_token}`}
          };
        if(final){
            let obj;
            if (props.location.state.function==1){
                obj = {"text":text,"college_id":variables.college_id}
            }
            if (props.location.state.function==3){
                obj = {"text":text,"college_id":variables.college_id,"changed_from_idea":props.location.state.changed_from_idea}
            }
            axios.post(apis.addidea,obj,options).
            then(response=>{
              if(response.data.success==1){
                let d= [];
                let e;
                if(props.location.state.function==3)
                {e = myIdea.create({
                    text: text,
                    id: response.data.id,
                    date: response.data.created_at,
                    changed_from_idea: props.location.state.changed_from_idea,
                });}
                if(props.location.state.function==1)
                {e = myIdea.create({
                    text: text,
                    id: response.data.id,
                    date: response.data.created_at,
                });}
                d.push(e);
                myIdeas.addMyIdeas(d);
              }
            },error=>{;})}
    }

    const EditIdea =()=>{
        ;
    }

    return (
        <div class="absolute w-full h-full">
            <div class="h-1/8 relative">
            <div class="h-4 bg-pink-500"></div>
            <div class="flex my-4 justify-around flex-row">
                <Link to={{pathname:"/home"}}><div class="flex-initial text-white bg-blue-700 w-20 text-center h-8">
                    <p class="pt-0.5">Back</p>
                </div>
                </Link>
                <div class="flex-initial w-40 text-center h-8">
                    <p class="text-xl">{props.location.state.function==1&&A}</p>
                    <p class="text-xl">{props.location.state.function==2&&B}</p>
                    <p class="text-xl">{props.location.state.function==3&&C}</p>
                </div>
            </div>
            </div>
            <textarea id="textAreaX" class='relative h-1/2 w-full p-5'/>
            
            <div class="flex my-8 justify-around flex-row">
                <div onClick={props.location.state.function==2?EditIdea:AddorChangeIdea} class="flex-initial text-white bg-blue-700 h-10 w-24 text-center">
                    <p class="pt-1.5">Submit</p>
                </div>
            </div>
        </div>
    );
})

export default IdeaFunctions;